import { ApolloCache, DefaultContext, MutationHookOptions, useMutation } from '@apollo/client';
import { UPLOAD_PRODUCT_NOTE_IMAGE_GQL } from './gql';

export interface UploadImageInput {
    base64_image: string;
    filename: string;
}

export interface UploadImageResponse {
    url: string;
    success: boolean;
    message?: string;
}

interface UploadVariables {
    input: UploadImageInput;
}

interface UploadData {
    uploadProductNoteImage: UploadImageResponse;
}

type MutationOptions = MutationHookOptions<UploadData, UploadVariables, DefaultContext, ApolloCache<any>>;

export const useUploadProductNoteImage = (options?: MutationOptions) => {
    return useMutation<UploadData, UploadVariables>(
        UPLOAD_PRODUCT_NOTE_IMAGE_GQL,
        options
    );
};
